<template>
    <div>
        <div class="pre-context" v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" v-if="!shownull">
            <div class="context-card flex flex-j-c-sa" v-for="(e, i) in pageLists" :key="i">
              <div class="card-left flex flex-j-c-sa flex-a-i-center">
                <div class="change-box" style="margin-bottom: 0.2rem;">
                  <img v-lazy="{src:e.avatar_url, loading:require('@/assets/loading.gif'), error:require('@/assets/error.jpg')}" class="avatar_img"/>
                  <p style="font-size:0.14rem;color:#333333">{{e.true_name}}</p>
                  <p style="margin-top:2px"><a :href="'tel:' + e.binding" style="color:#999">{{e.binding}}</a></p>
                </div>
                <div class="change-box" @click="showqrcode(e, i)">
                  <img src="@/assets/recruit/icon_qrcode@3x.png"/>
                  <p>支付二维码</p>
                </div>
              </div>
              <div class="card-right flex flex-j-c-center">
                <div class="flex text-line flex-a-i-center">
                  <p class="text-left">时间：</p>
                  <p class="text-right ellipsis">{{e.create_time}}</p>
                </div>
                <div class="flex text-line flex-a-i-center">
                  <p class="text-left">志愿：</p>
                  <p class="text-right ellipsis">{{e.first_name}}</p>
                </div>
                <!-- <div class="flex text-line flex-a-i-center" @click="showPopup('arrangement', e)">
                  <p class="text-left">层次：</p>
                  <p class="text-right ellipsis">{{e.second_name}}</p>
                </div> -->
                <div class="flex text-line flex-a-i-center">
                  <p class="text-left">专业：</p>
                  <p class="text-right ellipsis">【{{e.second_name}}】 {{e.goods_name}}</p>
                </div>
                <div class="flex text-line flex-a-i-center" v-if="e.inviter_name">
                  <p class="text-left">推荐人：</p>
                  <p class="text-right ellipsis">{{e.inviter_name}}</p>
                </div>
                <div class="flex text-line flex-a-i-center">
                  <p class="text-left">证件号码：</p>
                  <p>{{e.idcard}}</p>
                </div>
                <div class="flex text-line flex-a-i-center">
                  <p class="text-left">服务校区：</p>
                  <p class="text-right ellipsis">{{e.campus}}</p>
                </div>
                <div class="flex text-line flex-a-i-center" v-if="e.critical_true_name">
                  <p class="text-left">紧急联系人：</p>
                  <p class="text-right ellipsis">{{e.critical_true_name}}</p>
                </div>
                <div class="flex text-line flex-a-i-center" v-if="e.critical_mobile_phone">
                  <p class="text-left">紧急联系人手机号：</p>
                  <p class="text-right ellipsis">{{e.critical_mobile_phone}}</p>
                </div>
              </div>
            </div>
        </div>

        <DataNull v-if="shownull"/>
        <Nomore v-if="showNoMore"/>
    </div>
</template>

<script>
import {teacherForder} from '@/api';
import { Indicator, MessageBox, Toast } from 'mint-ui';
import DataNull from '@/components/DataNull';
import Nomore from '@/components/Nomore';

export default {
  name: 'PreNotRegistered',
  components: {
    DataNull,
    Nomore
  },
  data() {
    return {
      pageLists: [], // 页面列表
      loading: true,
      page: 1,
      shownull: false,
      showNoMore: false,
      kw: '' // 搜索词
    }
  },
  created() {
    this.kw = this.$route.query.kw || '';
    this.getpageData();
  },
  watch: {
    $route(a, b) {
      this.loading = true;
      this.page = 1;
      this.shownull = false;
      this.showNoMore = false;
      this.kw = this.$route.query.kw || '';
      this.pageLists = [];
      this.getpageData();
    }
  },
  methods: {
    // 加载更多
    loadMore() {
      if (this.loading) return false;
      this.loading = true
      this.page += 1;
      this.getpageData();
    },
    // 列表数据获取
    getpageData() {
      teacherForder({page: this.page, limit: 10, type: 1, keyword: this.kw}).then(res => {
        if (res.code === 0) {
          this.pageLists = this.pageLists.concat(res.data);
          if (res.data.length === 0) { this.shownull = true };
          if (res.data.length === 10) { this.loading = false; };
          if (res.data.length !== 10 && res.data.length !== 0) { this.showNoMore = true };
          if (Number(res.totalCount) === this.pageLists.length) { this.loading = true;this.showNoMore = true };
        } else {
          this.shownull = true;
        }
      });
    },
    // 支付二维码
    showqrcode(e, i) {
      this.$router.push({path:`/PreviewPay?pid=${e.order_no}&type=1`});
    },
  }
}
</script>

<style lang="less" scoped>
.pre-context{
  padding: 1.64rem 0 0.1rem;
  .context-card{
    width: 3.43rem;
    padding: 0.1rem;
    margin: 0 auto 0.1rem;
    background: white;
    border-radius: 5px;
    .change-box{
      img{
        width: 0.3rem;
        height: 0.3rem;
      }
      p{
        font-size: 0.125rem;
        color: #999;
      }
      .avatar_img{
        width: 0.62rem;
        height: 0.62rem;
        border-radius: 50%;
      }
    }
    .card-left{
      flex-direction: column;
    }
    .card-right{
      flex-direction: column;
      .text-line{
        line-height: 0.3rem;
        font-size: 0.125rem;
        .text-left{
          width: 0.8rem;
          text-align:right;
          color: #999;
        }
        .text-right{
          max-width: 1.5rem;
        }
      }
    }
  }
  .add-card{
    height: 1rem;
  }
  .text-style{
    border: none;
    background: #F6F6FA;
    border-radius: 3px;
    height: 0.25rem;
    padding: 0 0.05rem;
    min-width: 0.93rem;
  }
}
</style>
